// Maps data source name to its display label
//
// Implicit data sources are "not configured data sources".  We might end up
// breaking them down into further categories.
const IMPLICIT_DATA_SOURCES = {
  accuLynx:            'AccuLynx',
  broadly:             'Via Broadly',
  ccc:                 'CCC ONE',
  cdk:                 'CDK',
  dentrix:             'Dentrix',
  dentrixEnterprise:   'Dentrix Enterprise',
  eaglesoft:           'Eaglesoft',
  fieldEdge:           'FieldEdge',
  file:                'Added from file',
  ftp:                 'FTP',
  gingrApp:            'Gingr',
  jobNimbus:           'JobNimbus',
  kennelwood:          'Kennelwood',
  lankar:              'LANKAR',
  leadCentral:         'Added from web',
  member:              'Added by team member',
  mindbody:            'MINDBODY',
  mitchellManager:     'Mitchell Manager',
  napaTracs:           'NAPA TRACS',
  napaTracsEnterprise: 'NAPA TRACS Enterprise',
  neighborly:          'Neighborly',
  openDental:          'Open Dental',
  pawloyalty:          'PawLoyalty',
  petExec:             'PetExec',
  pawPartner:          'Paw Partner',
  petReserve:          'PetReserve',
  protractor:          'Mitchell Enterprise / Protractor',
  qbd:                 'QuickBooks Desktop',
  rbControlSystems:    'RB Control Systems',
  roWriter:            'R.O. Writer',
  serviceTitan:        'ServiceTitan',
  shopBoss:            'Shop Boss',
  shopWare:            'Shop-Ware',
  tcsTire:             'TCS Tire',
  tekmetric:           'Tekmetric',
  uploadClient:        'Integration',
  wintac:              'Wintac',
  zapier:              'Zapier'
};

// Configured data sources: any data source you can configure from the app
// itself, so only online data sources. Starting with just QuickBooks Online
const CONFIGURED_DATA_SOURCES = {
  booker:         'Booker',
  clio:           'Clio',
  housecallPro:   'Housecall Pro',
  jobber:         'Jobber',
  lightspeed:     'Lightspeed',
  qbo:            'QuickBooks Online',
  serviceFusion:  'Service Fusion',
  serviceMonster: 'ServiceMonster'
};



// qbo => QuickBooks Online
export function getDisplayName(name) {
  return IMPLICIT_DATA_SOURCES[name] || CONFIGURED_DATA_SOURCES[name];
}


// Returns data source with name and display name
export function getDataSource(dataSources, name) {
  const dataSource = dataSources.find(d => d.name === name);
  if (dataSource) {
    const displayName = getDisplayName(name);
    return { ...dataSource, displayName };
  } else
    return null;
}


// Implicit data sources, eg add one and file upload, but also Windows
// integrations (for now)
//
//  name          - Data source name (eg qbo)
//  displayName   - Display name (eg QuickBooks Online)
//  customers     - Number of customers, new or repeat
//  lastUpdateAt  - Last updated (record added, etc)
export function implicit(dataSources) {
  return withDisplayNames(IMPLICIT_DATA_SOURCES, dataSources)
    .filter(dataSource => dataSource.customers > 0);
}


// Configured data sources, eg QuickBooks Online, when configured by the
// business
//
//  name          - Data source name (eg qbo)
//  displayName   - Display name (eg QuickBooks Online)
//  customers     - Number of customers, new or repeat
//  status        - Status for configured sources (200, 401, 404, etc)
//  lastUpdateAt  - Last updated (record added, etc)
export function configured(dataSources) {
  return withDisplayNames(CONFIGURED_DATA_SOURCES, dataSources)
    .filter(dataSource => dataSource.status && dataSource.status !== 404);
}


// Configurable data sources, eg QuickBooks Online, that were not yet configured
// by the business
//
//  name          - Data source name (eg qbo)
//  displayName   - Display name (eg QuickBooks Online)
export function configurable(dataSources) {
  return withDisplayNames(CONFIGURED_DATA_SOURCES, dataSources)
    .filter(dataSource => !dataSource.status || dataSource.status === 404);
}

function withDisplayNames(displayNames, dataSources) {
  return Object.entries(displayNames)
    .map(([ name, displayName ]) => ({ ...dataSources.find(source => source.name === name), name, displayName }))
    .sort((a, b) => a.displayName.toLowerCase().localeCompare(b.displayName.toLowerCase()));
}
